import React from 'react'
import Navbar from '../../components/Navbar'
import HistorianCard from '../../components/HistorianCard'
import CuratorPortfolio from '../../components/CuratorPortfolio'

const Historian = () => {
    return(
      <>
       <HistorianCard />
       <CuratorPortfolio />
      </>
    )
  }
  
  export default Historian